<div class="finish-voting-modal">
  <div>
    <div class="title">{{title}}</div>
    <div><mat-checkbox [(ngModel)]="publishEndResult" >{{checkboxTitle}}</mat-checkbox></div>
    <div class="date-picker">
      <mat-form-field>
        <input [(ngModel)]="toDate" [matDatepicker]="pickerFrom" [min]="fromDate" matInput placeholder="{{'analytics.toDate' | translate}}">
        <mat-datepicker-toggle [for]="pickerFrom" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div class="button-right-container">
    <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate}}</button>
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate}}</button>
  </div>
</div>

